import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./GlobalConfig.css";
import "./cryptoEdge.scss";
import App from "./App";
import {store, persistor} from "./store/configureStore";
import {PersistGate} from "redux-persist/integration/react";
import {Provider} from "react-redux";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      <App />
    </PersistGate>
  </Provider>,
);
